// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export type InstrumentKey = string & {
  __type: 'InstrumentKey';
};

export type Instrument = {
  id: string;
  admin: string;
  displayName: string;
  key: InstrumentKey;
};

export const createInstrumentKey = (id: string, admin: string): InstrumentKey => {
  return `(ADMIN ${admin})(ID ${id})` as InstrumentKey;
};
